import React from 'react';
import AxiosDataWrapper
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataWrapper';
import AxiosDataIsLoaded
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataIsLoaded/AxiosDataIsLoaded';
import PropTypes from 'prop-types';
import QuickAlertFormWrapper from '../../QuickAlertForm/QuickAlertFormWrapper/QuickAlertFormWrapper';

function QuickAlertSummaryView(props) {
  const {
    hasAdvancedAlerting,
    setShowConfirmationPage,
    setQuickAlertsData,
    alertLimit,
    initialNotificationGroupId,
  } = props;

  return (
    <AxiosDataWrapper
      url="/alerts/data/create-quick-alerts"
      alternativeComponent={<></>}
      config={{ dataTitle: 'quickAlertList' }}
    >
      <AxiosDataIsLoaded>
        <QuickAlertFormWrapper
          hasAdvancedAlerting={hasAdvancedAlerting}
          setShowConfirmationPage={setShowConfirmationPage}
          setQuickAlertsData={setQuickAlertsData}
          alertLimit={alertLimit}
          initialNotificationGroupId={initialNotificationGroupId}
        />
      </AxiosDataIsLoaded>
    </AxiosDataWrapper>
  );
}

QuickAlertSummaryView.propTypes = {
  hasAdvancedAlerting: PropTypes.bool.isRequired,
  setShowConfirmationPage: PropTypes.func.isRequired,
  setQuickAlertsData: PropTypes.func.isRequired,
  alertLimit: PropTypes.number.isRequired,
  initialNotificationGroupId: (PropTypes.string || PropTypes.number).isRequired,
};

export default QuickAlertSummaryView;
